import { api } from '@services';

import Tag, { ITag, ITagApiModel } from '@models/Tag.model';
import { IPaginationResult } from '@models/Equipment.model';

export interface IFilterRequest {
  tagCategoryId?: string;
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
}
export interface IPagination {
  page: number;
  limit: number;
  search?: string;
}
interface IRequest {
  pagination?: IPagination;
  filter?: IFilterRequest;
}
export const getTags = async ({
  pagination,
  filter,
}: IRequest): Promise<IPaginationResult<ITag>> => {
  const { data: tags } = await api.get<IPaginationResult<ITagApiModel>>(
    `/tags?page=${pagination?.page || 1}&limit=${pagination?.limit || 20}${
      pagination?.search ? `&q=${encodeURIComponent(pagination.search)}` : ''
    }${filter?.sort ? `&sort=${filter.sort}` : ''}${
      filter?.direction ? `&direction=${filter.direction}` : ''
    }${filter?.tagCategoryId ? `&tagCategoryId=${filter.tagCategoryId}` : ''}`,
  );
  return Tag.arrayPaginatedFromApiModel(tags);
};
